import { Result } from '@empathy/search-types';
import { DiscoveryWallState } from '../../../models';
import { DISCOVERY_WALL_GETTERS_KEYS } from '../discovery-wall.const';
import { DiscoveryWallGetter } from '../discovery-wall.interfaces';

export class DiscoveryWallRecommendationsGetter implements DiscoveryWallGetter {
  getters = {
    [DISCOVERY_WALL_GETTERS_KEYS.clicksRecommendations]: (state: DiscoveryWallState): Result[] => state.clicksRecommendations.results,
    [DISCOVERY_WALL_GETTERS_KEYS.queriesRecommendations]: (state: DiscoveryWallState): Result[] => state.queriesRecommendations.results,
    [DISCOVERY_WALL_GETTERS_KEYS.sectionRecommendations]: (state: DiscoveryWallState): Result[] => state.sectionRecommendations.results,
    [DISCOVERY_WALL_GETTERS_KEYS.userRecommendations]: (state: DiscoveryWallState): Result[] => state.userRecommendations.results
  };
}
